import { render, staticRenderFns } from "./PreviewInternalDossierReport.vue?vue&type=template&id=12f05884&scoped=true"
import script from "./PreviewInternalDossierReport.vue?vue&type=script&lang=js"
export * from "./PreviewInternalDossierReport.vue?vue&type=script&lang=js"
import style0 from "./PreviewInternalDossierReport.vue?vue&type=style&index=0&id=12f05884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f05884",
  null
  
)

export default component.exports